<template>
  <div class="date-filter">
    <ul class="periods">
      <li
        class="periods__item"
        :class="{ 'periods__item--active': state.mode === modes.lastWeek }"
        @click="setMode(modes.lastWeek)"
      >
        Неделя
      </li>
      <li
        class="periods__item"
        :class="{ 'periods__item--active': state.mode === modes.lastMonth }"
        @click="setMode(modes.lastMonth)"
      >
        Месяц
      </li>
      <li
        class="periods__item"
        :class="{ 'periods__item--active': state.mode === modes.lastQuarter }"
        @click="setMode(modes.lastQuarter)"
      >
        Квартал
      </li>
      <li
        class="periods__item"
        :class="{ 'periods__item--active': state.mode === modes.lastYear }"
        @click="setMode(modes.lastYear)"
      >
        Год
      </li>
      <li
        class="periods__item"
        :class="{ 'periods__item--active': state.mode === modes.allTime }"
        @click="setMode(modes.allTime)"
      >
        Все время
      </li>
    </ul>
    <div class="custom-periods" @click="setMode(modes.manual)">
      <v-date-picker
        v-model="calendarData"
        mode="date"
        :masks="{ input: 'DD.MM.YYYY' }"
        :min-date="state.minDate"
        :max-date="new Date()"
        is-range
        is-required
      >
        <template v-slot="{ inputValue, togglePopover }">
          <div
            class="custom-periods__button button"
            :class="{
              'custom-periods--selected': state.mode === modes.manual,
              'custom-periods--not-selected': state.mode !== modes.manual,
            }"
            @click="togglePopover"
          >
            <svg
              class="custom-periods__icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.875 1.25V0H15.625V1.25H10.625V0H9.375V1.25H4.375V0H3.125V1.25C1.402 1.25 0 2.652 0 4.375V16.875C0 18.598 1.402 20 3.125 20H16.875C18.598 20 20 18.598 20 16.875V4.375C20 2.652 18.598 1.25 16.875 1.25ZM18.75 16.875C18.75 17.9089 17.9089 18.75 16.875 18.75H3.125C2.0911 18.75 1.25 17.9089 1.25 16.875V4.375C1.25 3.3411 2.0911 2.5 3.125 2.5V3.75H4.375V2.5H9.375V3.75H10.625V2.5H15.625V3.75H16.875V2.5C17.9089 2.5 18.75 3.3411 18.75 4.375V16.875Z"
              />
              <path
                d="M4.375 7.8125C4.89277 7.8125 5.3125 7.39277 5.3125 6.875C5.3125 6.35723 4.89277 5.9375 4.375 5.9375C3.85723 5.9375 3.4375 6.35723 3.4375 6.875C3.4375 7.39277 3.85723 7.8125 4.375 7.8125Z"
              />
              <path
                d="M8.125 7.8125C8.64277 7.8125 9.0625 7.39277 9.0625 6.875C9.0625 6.35723 8.64277 5.9375 8.125 5.9375C7.60723 5.9375 7.1875 6.35723 7.1875 6.875C7.1875 7.39277 7.60723 7.8125 8.125 7.8125Z"
              />
              <path
                d="M11.875 7.8125C12.3928 7.8125 12.8125 7.39277 12.8125 6.875C12.8125 6.35723 12.3928 5.9375 11.875 5.9375C11.3572 5.9375 10.9375 6.35723 10.9375 6.875C10.9375 7.39277 11.3572 7.8125 11.875 7.8125Z"
              />
              <path
                d="M15.625 7.8125C16.1428 7.8125 16.5625 7.39277 16.5625 6.875C16.5625 6.35723 16.1428 5.9375 15.625 5.9375C15.1072 5.9375 14.6875 6.35723 14.6875 6.875C14.6875 7.39277 15.1072 7.8125 15.625 7.8125Z"
              />
              <path
                d="M4.375 11.5625C4.89277 11.5625 5.3125 11.1428 5.3125 10.625C5.3125 10.1072 4.89277 9.6875 4.375 9.6875C3.85723 9.6875 3.4375 10.1072 3.4375 10.625C3.4375 11.1428 3.85723 11.5625 4.375 11.5625Z"
              />
              <path
                d="M8.125 11.5625C8.64277 11.5625 9.0625 11.1428 9.0625 10.625C9.0625 10.1072 8.64277 9.6875 8.125 9.6875C7.60723 9.6875 7.1875 10.1072 7.1875 10.625C7.1875 11.1428 7.60723 11.5625 8.125 11.5625Z"
              />
              <path
                d="M11.875 11.5625C12.3928 11.5625 12.8125 11.1428 12.8125 10.625C12.8125 10.1072 12.3928 9.6875 11.875 9.6875C11.3572 9.6875 10.9375 10.1072 10.9375 10.625C10.9375 11.1428 11.3572 11.5625 11.875 11.5625Z"
              />
              <path
                d="M15.625 11.5625C16.1428 11.5625 16.5625 11.1428 16.5625 10.625C16.5625 10.1072 16.1428 9.6875 15.625 9.6875C15.1072 9.6875 14.6875 10.1072 14.6875 10.625C14.6875 11.1428 15.1072 11.5625 15.625 11.5625Z"
              />
              <path
                d="M4.375 15.3125C4.89277 15.3125 5.3125 14.8928 5.3125 14.375C5.3125 13.8572 4.89277 13.4375 4.375 13.4375C3.85723 13.4375 3.4375 13.8572 3.4375 14.375C3.4375 14.8928 3.85723 15.3125 4.375 15.3125Z"
              />
              <path
                d="M8.125 15.3125C8.64277 15.3125 9.0625 14.8928 9.0625 14.375C9.0625 13.8572 8.64277 13.4375 8.125 13.4375C7.60723 13.4375 7.1875 13.8572 7.1875 14.375C7.1875 14.8928 7.60723 15.3125 8.125 15.3125Z"
              />
              <path
                d="M11.875 15.3125C12.3928 15.3125 12.8125 14.8928 12.8125 14.375C12.8125 13.8572 12.3928 13.4375 11.875 13.4375C11.3572 13.4375 10.9375 13.8572 10.9375 14.375C10.9375 14.8928 11.3572 15.3125 11.875 15.3125Z"
              />
            </svg>
            <span> {{ inputValue.start }} — {{ inputValue.end }}</span>
            <!--          <div @mouseover="startInputVisible =true" @mouseleave="(startInputVisible = false) && inputEvents.start()">-->
            <!--            <input type="text" v-if="startInputVisible && modeInternal === modes.manual" :value="inputValue.start" v-on="inputEvents.start">-->
            <!--            <label v-else>{{ inputValue.start }}</label>-->
            <!--          </div>-->
            <!--          —-->
            <!--          <div @mouseover="endInputVisible =true" @mouseleave="endInputVisible =false">-->
            <!--            <input type="text" v-if="endInputVisible && modeInternal === modes.manual" :value="inputValue.end" v-on="inputEvents.end">-->
            <!--            <label v-else>{{ inputValue.end }}</label>-->

            <!--          </div>-->
          </div>
        </template>
      </v-date-picker>
    </div>
  </div>
</template>
<script>
import { ref, watch, computed } from "vue";

import modes from "@/modules/datePickerModes";

export default {
  props: {
    from: {
      type: Date,
    },
    to: {
      type: Date,
    },
    minDate: {
      type: Date,
      default: () => {
        return new Date(2022);
      },
    },
    mode: {
      type: String,
      default: () => {
        return modes.lastWeek;
      },
    },
  },
  emits: ["datesChanged"],
  setup(props, { emit }) {
    const state = ref({
      minDate: props.minDate,
      from: props.from,
      to: props.to,
      mode: props.mode,
    });
    const calendarData = computed({
      get: () => {
        return { start: state.value.from, end: state.value.to };
      },
      set: (value) => {
        const res = {
          range: {
            ...value,
          },
          mode: state.value.mode,
        };

        emit("datesChanged", res);
      },
    });

    const recalculateInterval = () => {
      const now = new Date();
      let start = new Date();
      let end = new Date();

      switch (state.value.mode) {
        case modes.lastWeek: {
          start = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() - (now.getDay() - 1) - 7
          );
          end = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate() + 6
          );
          break;
        }
        case modes.lastMonth: {
          end.setDate(0); //сдвигаем на последний день прошлого месяца
          start.setDate(0); //сдвигаем на последний день прошлого месяца чтобы сдвинуть на первый
          start.setDate(1);
          break;
        }
        case modes.lastQuarter: {
          const month = now.getMonth() + 1;
          const currentQuarterIndex = Math.ceil(month/3 - 1);
          const quarterStartingMonth = (currentQuarterIndex - 1) * 3;
          start.setMonth(quarterStartingMonth);
          start.setDate(1);
          end = new Date(start);
          end.setMonth(end.getMonth() + 3);
          end.setDate(0);
          break;
        }
        case modes.lastYear: {
          start = new Date(now.getFullYear() - 1, 0, 1); //1 января
          end = new Date(now.getFullYear(), 0, 0); //31 декабря
          break;
        }
        case modes.allTime:
          start = state.value.minDate;
          break;
        case modes.manual: {
          const today = new Date(Date.now());
          start.setFullYear(today.getFullYear());
          start.setMonth(today.getMonth() + 1);
          start.setDate(today.getDate());
          end.setFullYear(today.getFullYear());
          end.setMonth(today.getMonth() + 1);
          end.setDate(today.getDate());
        }
         
          break;
      }

      if (start < state.value.minDate) start = state.value.minDate;
      if (end < state.value.minDate) end = state.value.minDate;

      state.value.from = start;
      state.value.to = end;
    };

    watch(() => state.value.minDate, recalculateInterval);
    watch(() => state.value.mode, recalculateInterval);

    const setMode = (mode) => {
      state.value.mode = mode;
    };
    const startInputVisible = ref(false);
    const endInputVisible = ref(false);

    if (state.value.mode !== modes.manual) recalculateInterval();

    return {
      state,
      modes,
      calendarData,
      startInputVisible,
      endInputVisible,
      setMode,
    };
  },
};
</script>
<style scoped>
.date-filter {
  display: flex;
  gap: 12px;
}
.periods {
  display: flex;
  list-style: none;
  height: 48px;
  margin: 0;
  padding: 0;
  font-family: var(--font-family);
  font-size: 16px;
}

.periods__item {
  white-space: nowrap;
  border: 1px solid var(--basic-grey);
  border-radius: 0;
  padding-top: 13px;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;
}

.periods__item:hover,
.periods__item:focus,
.custom-periods--not-selected:hover,
.custom-periods--not-selecte:focus {
  border-color: var(--secondary-blue-darker);
}

.periods__item:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.periods__item:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.periods__item--active {
  background-color: var(--primary-blue-lighter);
  border-color: var(--primary-blue-lighter);
  color: var(--basic-white);
}

.custom-periods {
  display: flex;
  gap: 8px;
  align-items: center;
}

.custom-periods__button {
  height: 48px;
  width: 100%;
  min-width: 232px;
  padding-top: 9px;
}

.custom-periods__icon {
  position: relative;
  top: 4px;
  margin-right: 4px;
}

.custom-periods--selected {
  border: 1px solid var(--basic-blue-lighter);
  background-color: var(--primary-blue-lighter);
  color: var(--basic-white);
}

.custom-periods--not-selected {
  border: 1px solid var(--basic-grey);
}

.custom-periods--selected path {
  fill: var(--basic-white);
}

.custom-periods--not-selected path {
  fill: var(--basic-black);
}
</style>
